module.exports = "<ul id=\"u-menu\">\n  <li *ngFor=\"let p of pageList\" style=\"margin-top: 7px;\">\n    <a href=\"\" routerLink=\"{{p.KP_Redirect_URL}}\" routerLinkActive=\"menu-active\">\n      <img src=\"/assets/images/icons/{{p.KP_Image_URL}}\">\n      <span style=\"display:block;font-size:13px;\">{{p.KHB_Page}}</span>\n    </a>\n  </li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Issues/issue-menu/issue-menu.component.html
// module id = ./src/app/Issues/issue-menu/issue-menu.component.html
// module chunks = main